module.exports = __webpack_public_path__ + "img/network-accesses.022b061a.svg";